import { Grid } from '@mui/material'
import FormControlRadio, { radioButtonChoiceOptions } from 'components/FormControlRadio'
import FormInput from 'components/FormInput'
import { FormInputSelect, ItemOption } from 'components/FormInputSelect'
import React, { useCallback, useEffect, useState } from 'react'
import { Control, UseFormSetValue, UseFormWatch } from 'react-hook-form'
import genericService from 'services/generic.service'
import { HearingIdentificationType } from 'types/hearing-identification.type'
import { useHearingIdentificationBlockFieldsContext } from '../../../../../../contexts/hearing-identification-block-fields.context'
import FormInputDatePicker from 'components/FormInputDatePicker'

type WorkingGroupProps = {
  control: Control<HearingIdentificationType>
  watch: UseFormWatch<HearingIdentificationType>
  setValue: UseFormSetValue<HearingIdentificationType>
}

export const WorkingGroup: React.FC<WorkingGroupProps> = ({ control, watch }) => {
  const { isBlockedFields } = useHearingIdentificationBlockFieldsContext()
  const [salaryAmountOptions, setSalaryAmountOptions] = useState<ItemOption[]>([])

  const isWorking = watch('identificacaoAdolescente.exerceAtividadeRemunerada')

  const fillSalaryAmountOptions = useCallback(async (): Promise<void> => {
    await genericService
      .get('/faixa-renda')
      .then((res) => res && setSalaryAmountOptions(res.data))
      .catch((error) => console.log('error', error))
  }, [setSalaryAmountOptions])

  useEffect(() => {
    fillSalaryAmountOptions()
  }, [fillSalaryAmountOptions])

  return (
    <>
      <Grid item lg={isWorking === 'S' ? 4 : 12} xs={12}>
        <FormControlRadio
          control={control}
          name='identificacaoAdolescente.exerceAtividadeRemunerada'
          label='Exerce alguma atividade remunerada?'
          options={radioButtonChoiceOptions}
          disabled={isBlockedFields}
        />
      </Grid>
      {isWorking === 'S' && (
        <>
          <Grid item lg={4} xs={12}>
            <FormInput
              control={control}
              name='identificacaoAdolescente.descricaoAtividadeRemunerada'
              label='Atividade'
              maxLength={60}
              placeholder='Informe a atividade'
            />
          </Grid>
          <Grid item lg={4} xs={12}>
            <FormInputSelect
              control={control}
              name='identificacaoAdolescente.idValorRemuneracao'
              label='Valor da remuneração'
              options={salaryAmountOptions}
            />
          </Grid>
        </>
      )}
    </>
  )
}
